import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";
import { globalAlertRef } from "./components/AlertModalProvider";

import "./index.scss";
import Constants from "./helpers/Constants";

// TODO(remove): 로컬 코드 반영 확인용 임시 프로브 — 확인 후 삭제
console.log("%c[LOCAL PROBE] build 2026-07-03 v5 — 폴링 감지 테스트", "color:#fff;background:#7a6eff;padding:2px 6px;border-radius:4px");

// Router 의 getUserConfirmation — 에디터 dirty 이탈 경고를 DS 모달(showAlert)로 통일.
//   history.block(message) 으로 등록된 메시지가 [PREFIX] 로 시작하면 우리 모달 사용.
//   AlertModalProvider 가 globalAlertRef.showAlert 에 등록함.
const DIRTY_BLOCK_PREFIX = "DIRTY_BLOCK::";
export const dirtyBlockMessage = (jsonOpts = {}) =>
  DIRTY_BLOCK_PREFIX + JSON.stringify(jsonOpts);

const getUserConfirmation = (message, callback) => {
  if (message && message.startsWith(DIRTY_BLOCK_PREFIX) && globalAlertRef.showAlert) {
    let opts = {};
    try {
      opts = JSON.parse(message.slice(DIRTY_BLOCK_PREFIX.length));
    } catch (e) {
      // ignore parse error → default opts
    }
    globalAlertRef
      .showAlert({
        title: opts.title || "변경 사항이 있어요",
        description:
          opts.description || "저장하지 않고 나가시겠습니까?\n작성 중인 내용이 사라집니다.",
        buttons: [
          { text: opts.cancelText || "계속 작성", value: "cancel", color: "coleGray" },
          { text: opts.confirmText || "나가기", value: "confirm", color: "lightRed" },
        ],
      })
      .then((r) => callback(r === "confirm"));
  } else {
    // fallback — message 가 빈 string 인 경우 등 native confirm
    // eslint-disable-next-line no-alert
    callback(window.confirm(message || ""));
  }
};

document.documentElement.lang = "ko";

Bugsnag.start({
  apiKey: "2ea89ff57eebd7cd111e26bfeaf3bd77",
  appVersion: process.env.REACT_APP_VERSION,
  plugins: [new BugsnagPluginReact()],
});
const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

const errorCallback = (event) => {
  if (event?.errors && event.errors[0]) {
    const error = event.errors[0];

    if (error.errorClass === Constants.ERROR.CHUNK_LOAD) {
      window.location.reload();
    }
  }
};

// NOTE: google translation crash workaround
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) {
        console.error(
          "Cannot remove a child from a different parent",
          child,
          this
        );
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.error(
          "Cannot insert before a reference node from a different parent",
          referenceNode,
          this
        );
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

ReactDOM.render(
  <ErrorBoundary onError={errorCallback}>
    <Router getUserConfirmation={getUserConfirmation}>
      <App />
    </Router>
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
